export function addClass(el,  classname) {
  if (!el.classList.contains( classname)) {
    el.classList.add( classname);
  }
}

export function removeClass(el,  classname) {
  el.classList.remove( classname);
}
